import React from 'react'
import { connect, useDispatch } from 'react-redux'
import { clubs } from 'redux/modules'
import PropTypes from 'prop-types'
import { setCurrentTheme } from 'redux/modules/themes'
import Loader from './Loader'

/**
 * Load and store current team's club.
 */
const ClubLoader = ({ children, fetchClubV2, team, ...rest }) => {
  const dispatch = useDispatch()

  return (
    <>
      {team && (
        <Loader
          fetchMethod={() =>
            fetchClubV2(team.club_uuid).then((res) => {
              const clubData = res.response.data
              let clubTheme = {}
              if (clubData.theme_temp) {
                try {
                  clubTheme = JSON.parse(clubData.theme_temp) ?? {}
                } catch (error) {
                  console.error('Error parsing JSON:', error)
                }
              }
              // Store the club theme in Redux
              dispatch(setCurrentTheme(clubTheme.theme))
            })
          }
          triggers={[team.club_uuid]}
          {...rest}
        >
          {children}
        </Loader>
      )}
    </>
  )
}

ClubLoader.defaultProps = {
  teams: [],
}

ClubLoader.propTypes = {
  children: PropTypes.node.isRequired,
  fetchClubV2: PropTypes.func.isRequired,
  teams: PropTypes.arrayOf(PropTypes.object.isRequired),
  team: PropTypes.shape({
    club_uuid: PropTypes.string.isRequired,
  }).isRequired,
}

export default connect(
  ({ team }) => ({
    team,
  }),
  { fetchClubV2: clubs.fetchClubV2 }
)(ClubLoader)
